<template>

  <div>
    <h5>Upload Documents</h5>
    <form-component>
      <form>
        <uploader v-if="user && user.counselor_profile" />
      </form>
    </form-component>

    <hr>

    <h5>Documents</h5>
    <document-table />

  </div>
</template>

<script>
import DocumentTable from '../components/DocumentTable.vue'
import Uploader from '../Uploader/Uploader.vue'
import Documents from '../documents.js'
import FormComponent from '@/components/FormComponent.vue';

export default {
  name:'OfficialDocuments',
  components: {
    DocumentTable,
    Uploader,
    FormComponent,
  },
  data() {
    return {
      documents: new Documents(),
      user: null,
    }
  },
  provide(){
    return {
      documents: this.documents,
    }
  },
  async mounted() {
    this.user = this.$store.getters.currentUser;
    const counselor = this.user.counselor_profile;

    await this.documents.initialize(this.$http, counselor.id);
  }
}
</script>

<style lang="scss" scoped>
.account {
  .profile-button {
    @media (min-width: $md-min) {
      min-width: 150px;
    }
  }

  label {
    @include label;

    font-size: 12px;
  }

  h2 {
    margin-top: 10px;
    font-size: 28px;
    margin-bottom: 30px;
  }

  .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
    color: white;
  }

  .upload-btn {
    width: 100%;
    margin-top: 10px;

    i,
    svg {
      margin-right: 7px;
    }
  }

  .right-lg {
    opacity: 0.75;
    position: relative;
    top: -8px;

    label {
      text-transform: none !important;
    }

    @media (min-width: $md-min) {
      text-align: right;
      top: 0;
    }
  }

  .add-file-btn {
    height: 45px;
    width: 100%;
    border-color: $green;
    background: none;
    color: $green;

    &:hover {
      border-color: $green;
      background: $green;
      color: #1c3a58;
    }
  }
}
</style>